import { FormProvider } from "react-hook-form"
import { Spacer } from "../../../../../components/spacer/Spacer"
import { theme } from "../../../../../styles/stitches.config"
import { ContainerLarge, CenterWrapper } from "../components/CenterWrapper"
import { NavigationButtons } from "../components/NavigationButtons"
import { SectionHeader } from "../components/SectionHeader"
import {
  SelectionDisclaimer,
  HouseholdSelectionDisclaimerNew,
} from "../../acquisitionForm/sections/contractTypeSection/ContractSelectionDisclamer"
import { SpotDisclaimers } from "../../acquisitionForm/sections/contractTypeSection/SpotDisclaimers"
import { ContractTypeSelection } from "./ContractTypeSelection"
import { useContractTypeFormController } from "./contractTypeFormController"

export function HouseholdContractTypeForm() {
  const controller = useContractTypeFormController("household")

  return (
    <FormProvider {...controller.form}>
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form onSubmit={controller.handleSubmit}>
        <ContainerLarge css={{ maxWidth: 946 }}>
          <SectionHeader
            stepsNum={controller.progress.currentStep}
            maxSteps={controller.progress.totalSteps}
            subHeading="Jsem domácnost"
          >
            Typ smlouvy
          </SectionHeader>

          <Spacer size={theme.space.s6} />

          <SelectionDisclaimer>
            <HouseholdSelectionDisclaimerNew />
          </SelectionDisclaimer>

          <Spacer size={theme.space.s12} />

          <SpotDisclaimers type="household" />

          <Spacer size={theme.space.s12} />

          <ContractTypeSelection
            value={controller.product}
            productionDataTariff={controller.productionDataTariff}
            onProductionDataTariffChange={controller.handleProductionDataTariffChange}
            onChange={controller.handleProductChange}
          />
        </ContainerLarge>

        <Spacer size={theme.space.s12} />

        <CenterWrapper>
          <NavigationButtons
            prevText="Nejste domácnost?"
            nextText="Osobní údaje"
            onReturn={controller.handleReturn}
            // validationCompleted={controller.productSelectionValidated}
          />
        </CenterWrapper>
      </form>
    </FormProvider>
  )
}
